import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import { PendingPoCard } from "./PendingPoCard";
import GCPendingPoCard from "./GCPendingPoCard";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { Typography } from "@mui/material";

const GCPallet = ({
  xOpen = false,
  fCloseDetailModal,
  xTitle = "Pending Po Detail",
  Data=[],
}) => {
  console.log('data', Data);
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  return (
    <Modal
      open={xOpen}
      onClose={fCloseDetailModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-gc-search"
      >
        <GCTitleSticky title={xTitle} onClose={fCloseDetailModal} />

        <div className="p-2">
       
          <Grid container spacing={1} className="easy-putaway-container">
            {Data?.map((item, index) => (
              <Grid item xs={12} sm={6} md={6} key={index}>
                <div className="easy-putaway-card">
                  <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
                    <Grid item xs={12} md={12}>
                      <Typography variant="body1" className="value">
                        {item?.itemName}
                      </Typography>
                    </Grid>

                    
                    <Grid item xs={3} md={3}>
                      <Typography variant="subtitle1" className="label">
                        BIN CBM
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="body1" className="value">
                        {item?.G_CBM}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="subtitle1" className="label">
                        CTN Qty
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="body1" className="value">
                        {item?.totalCTNQty}
                      </Typography>
                    </Grid>

                    <Grid item xs={3} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Pallet
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="body1" className="value">
                        {item?.totalPallet}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Qty / Pallet
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="body1" className="value">
                        {item?.QtyPerPallet}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="subtitle1" className="label">
                        BaseQty / Pallet
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="body1" className="value">
                        {item?.BaseQtyPerPallet}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="subtitle1" className="label">
                      BinSize
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="body1" className="value">
                        {item?.BinSize}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="subtitle1" className="label">
                      RefNo
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={3}>
                      <Typography variant="body1" className="value">
                        {item?.SuppRefNo1}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={3} md={3}>
                <Typography variant="subtitle1" className="label">
               Ref. No
                </Typography>
              </Grid> */}
                    {/* <Grid item xs={6} md={6}>
                      <Typography variant="body1" className="value">
                        {item?.SuppRefNo1}
                      </Typography>
                    </Grid> */}
                  </Grid>
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default GCPallet;
